import { AxiosError } from 'axios';

export function getStatusCodeFromAxiosError(error: unknown): Number {
  if (error && typeof error === 'object' && 'response' in error) {
    return (error as AxiosError).response.status;
  }
  if (error && typeof error === 'object' && 'request' in error) {
    return (error.request as XMLHttpRequest).status;
  }
  return 500;
}
